var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#828292",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1612 5.30219C10.5635 5.7051 10.574 6.3663 10.1612 6.76922L7.13034 9.72714H15.207C18.1303 9.72714 20.5 12.0399 20.5 14.8927V17.9669C20.5 18.5375 20.0261 19 19.4414 19C18.8568 19 18.3828 18.5375 18.3828 17.9669V14.8927C18.3828 13.181 16.961 11.7934 15.207 11.7934H7.09456L10.1612 14.7862C10.574 15.1891 10.574 15.84 10.1612 16.2429C9.74835 16.6458 9.08143 16.6458 8.66858 16.2429L3.80964 11.5009C3.39679 11.098 3.39679 10.4471 3.80964 10.0442L8.66858 5.30219C9.08143 4.89927 9.74835 4.89927 10.1612 5.30219Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack);
export default __webpack_public_path__ + "static/media/GoBack.e689f764.svg";
export { ForwardRef as ReactComponent };